import {VNode} from 'snabbdom';

import {KeyModifiers} from 'common/util/keyboard';

export enum Direction {
  Right = `right`,
  Left = `left`,
  Top = `top`,
  Bottom = `bottom`,
}

export enum PanelName {
  Events = `Events Menu Sidebar`,
  DataTable = `Data Table`,
  Properties = `Properties Menu Sidebar`,
  QueryPanel = `Query Panel`,
  SideNav = `Side Nav`,
  MultiMetrics = `Multi Metrics Menu Sidebar`,
}

export interface ResizablePanelAttrs {
  'disable-collapsing'?: boolean;
  loading?: boolean;
  'min-adjacent-size'?: number;
  'max-size'?: number;
  'max-auto-size'?: number;
  'min-size'?: number;
  'default-size'?: number;
  'storage-key'?: string;
  'show-collapse-button'?: boolean;
  'show-alignment-toggle'?: boolean;
  'panel-name'?: PanelName;
  'default-alignment'?: Direction;
  'default-ratio'?: number;
  'collapse-key'?: string;
  'collapse-key-modifier'?: KeyModifiers;
  'show-resizing-layout'?: boolean;
  'fixed-size'?: boolean;
  'disable-responsive-resize'?: boolean;
}

export interface ResizablePanelState {
  hasOpenDropdown: boolean;
  isHoveringAlignmentToggle: boolean;
  canExpand: boolean;
  hasResized: boolean;
  alignment?: Direction;
  isCollapsed: boolean;
  isResizing: boolean;
  size: number;
  currentRatio?: number;
  containerWidth: number;
  containerHeight: number;
  snapResetState?: boolean;
}

export type PersistedResizablePanelState = Pick<
  ResizablePanelState,
  'alignment' | 'isCollapsed' | 'size' | 'currentRatio'
>;

export interface ResizablePanelJsxProps {
  attrs?: ResizablePanelAttrs;
  on?: {
    panelResize?: (ev: CustomEvent<{size: number; isCollapsed: boolean}>) => void;
    updateAlignment?: (ev: CustomEvent<{newAlignment: Direction}>) => void;
  };
  props?: {
    containerEl?: HTMLElement;
    headerContent?: VNode;
  };
}
